import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helpers";
import {LOAD_USER_RIGHT} from "./mutation-types";

export const loadMainPerimeters = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/main/perimeters', data).then((response) => {
            commit(types.LOAD_MAIN_PERIMETERS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadPerimeters = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/perimeters', data).then((response) => {
            commit(types.LOAD_PERIMETERS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updatePerimeter = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/'+ data.id +'/perimeter', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createPerimeter = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/perimeter', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deletePerimeter = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/perimeter').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const importPerimeters = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`import/perimeters`, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setPerimeterAccessMethods = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`set/perimeter/${data.perimeter}/access-methods`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updatePerimeterAccessMethods = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/perimeter/${data.perimeter}/access-methods/${data.key}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deletePerimeterAccessMethods = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/perimeter/${data.perimeter}/access-methods/${data.key}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getPerimeterUserAccess = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/perimeter/${id}/users-with-access`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getPerimeterGroupAccess = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/perimeter/${id}/groups`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadUserAssignRightToDoor = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/user/assign/to/door/${id}`).then((response) => {
            commit(types.LOAD_USER_RIGHT, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadUserAssignDoorSonote = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/assin/sonote').then((response) => {
            commit(types.LOAD_USER_DOOR_SONOTE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const assignRightAccessToDoor = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('assign/user/right/to/door', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeRightAccessToDoor = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`remove/user/${data.user_id}/right/from/door/${data.door_id}`)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}


